import ArrowRoundedCornerIcon from 'components/Icons/Arrows/ArrowRoundedCorner'

type Props = {
  height?: number,
  fill?: string,
  className?: string,
  tailScale?: number,
}

const arrowWidth = 10
const tailWidth = 61
const gapWidth = 2

const StraightArrowIcon = ({ height = 30, fill = '#EB48A0', className, tailScale = 1 }: Props) =>
  <div>
    <div className='absolute -top-[10px] -left-[12px]'>
      <ArrowRoundedCornerIcon fill={fill} />
    </div>
    <svg height={height} fill='none' viewBox='0 0 73 18' className={className} style={{ position: 'absolute', right: '-8px', top: '-12px', transition: 'all linear 400ms' }}>
      {/* <path d='M69 9.06024L61 4L61 14L69 9.06024Z' fill={fill} stroke={fill} strokeWidth='4' style={{ position: 'relative', left: (tailScale - 1) * tailWidth }} />
      <rect x='61' y='11' width={61 * tailScale} height='4' transform='rotate(-180 61 11)' fill={fill}/> */}
      {/* <g transform={`translate(${61 * (tailScale - 1)}, 0)`}> */}
        <path d="M69 9.06024L61 4L61 14L69 9.06024Z" fill={ fill } stroke={ fill } strokeWidth="4"/>
      {/* </g> */}
      {/* <rect x="0" y="7" width={61 * tailScale} height="4" fill={ fill } /> */}
    </svg>
    <div style={{ height: '6px', backgroundColor: fill, width: arrowWidth + gapWidth + (tailWidth * tailScale), transition: 'all linear 400ms' }} />
  </div>

export default StraightArrowIcon
